export const fmt = (v: string | number | null | undefined): string => {
    if (v === null || v === undefined || v === '') return '—';
    const n = typeof v === 'number' ? v : parseFloat(v as string);
    return isNaN(n) ? '—' : n.toString();
};

export const pair = (
    a: string | number | null | undefined,
    b: string | number | null | undefined,
) =>
    a !== null && a !== undefined && a !== '' &&
    b !== null && b !== undefined && b !== ''
        ? `${fmt(a)} / ${fmt(b)}`
        : '—';

/** Which clients an order covers: 0 (or absent) means every eligible client in the scheme. */
export const clientScopeLabel = (clientCount: number | null | undefined): string =>
    clientCount ? `${clientCount} selected` : 'All';
